import { gql } from "apollo-angular";

export const CREATE_TEST_CASE_MUTATION = gql`mutation configuratorCreateTestCase($TestCase: TestCaseInput) {
    configuratorCreateTestCase(TestCase: $TestCase) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const UPDATE_TEST_CASE_MUTATION = gql`mutation configuratorUpdateTestCase($TestCase: TestCaseInput) {
    configuratorUpdateTestCase(TestCase: $TestCase) {
        responseMessages
        returnValue
        success
    }
  }
  `
  

export const DELETE_TEST_CASE_MUTATION = gql`mutation configuratorDeleteTestCase($Uid: String!) {
    configuratorDeleteTestCase(Uid: $Uid)
  }
  `

export const IMPORT_TEST_CASES_MUTATION = gql`mutation configuratorImportTestCases($TestCases: [TestCaseInput]) {
    configuratorImportTestCases(TestCases: $TestCases) {
        responseMessages
        returnValue
        success
    }
  }
  `
  